/* Logo component that displays the thuisverpleging logo */
import React from 'react';

interface LogoProps {
  width?: number;
  height?: number;
  className?: string;
}

const ThuisverpleegLogo: React.FC<LogoProps> = ({ 
  width = 100, 
  height = 100, 
  className 
}) => {
  return (
    <img
      src="/logo.png"
      alt="Thuisverpleging Logo"
      width={width}
      height={height}
      className={className}
      style={{
        objectFit: 'contain',
        display: 'block'
      }}
    />
  );
};

export default ThuisverpleegLogo;